import { storeToRefs } from "pinia"
import { GenericModelController } from "@/controllers/model-controllers/abstract/generic-model-controller"
import type { IProductionStatementApproval } from "@/interfaces/api/production-statement-approval.interface"
import { ProductionStatementApproval } from "@/models/production-statement-approval.model"
import { ProductionStatementApprovalRepository } from "@/repositories/production-statement-approval-repository"
import { useProductionStatementApprovalStore } from "@/store/production-statement-approvals.store"
import { useSocketSynchronizationHandlers } from "@/composables/socket/socket-synchronization-handlers"
import type { IRepositoryRequestConfig } from "@/interfaces/repository/repository-request-config.interface"

export class ProductionStatementApprovalController extends GenericModelController<
  ProductionStatementApproval,
  IProductionStatementApproval,
  ProductionStatementApprovalRepository
> {
  constructor() {
    const productionStatementApprovalStore = useProductionStatementApprovalStore()
    const { productionStatementApprovals } = storeToRefs(productionStatementApprovalStore)

    super(
      ProductionStatementApproval,
      { collection: productionStatementApprovals },
      new ProductionStatementApprovalRepository()
    )

    this.socketSynchronizationHandlers = useSocketSynchronizationHandlers(
      ProductionStatementApproval,
      productionStatementApprovals
    )
  }

  /** Mark the approval deleted (PNTS-3227); the server removes its allocations and answers with the card. */
  public async softDelete(
    approval: ProductionStatementApproval,
    requestConfig?: IRepositoryRequestConfig
  ): Promise<ProductionStatementApproval | undefined> {
    return await this.update(approval, { ...requestConfig, query: { delete: true } }, true)
  }

  public async restore(
    approval: ProductionStatementApproval,
    requestConfig?: IRepositoryRequestConfig
  ): Promise<ProductionStatementApproval | undefined> {
    return await this.update(approval, { ...requestConfig, query: { restore: true } }, true)
  }
}
